export default {
  VOLTRON_BASE: {
    l: "https://gfn-analytics-api-dev.us-e1.cloudhub.io/api/",
    d: "https://gfn-analytics-api-dev.us-e1.cloudhub.io/api/",
    s: "https://api-stage.nvidia.com/gfn-analytics-api-stg/api/",
    p: "https://api-prod.nvidia.com/gfn-analytics-api/api/",
  },
  VOLTRON_BASE_CN: {
    l: "https://api-stage.nvidia.cn/muleapp/api/",
    d: "https://api-stage.nvidia.cn/muleapp/api/",
    s: "https://api-stage.nvidia.cn/muleapp/api/",
    p: "https://api-prod.nvidia.cn/muleapp/api/",
  },
  ANALYTICS_ENDPOINT: "v1/gxt/events",
  CLIENT_ID: "94211547528691713",
  CLIENT_DESCRIPTION: "NVIDIA WEB PORTAL",
  DEVICE_ID: "NVIDIA_WEB_PORTAL",
  JARVIS_DELEGATE_REDEEM: "/api/1/authentication/delegate/redeem",
};
